import { forwardRef } from "react";
import { Minus, TrendingDown, TrendingUp } from "lucide-react";

export const DeltaBadge = forwardRef<HTMLSpanElement, { pct: number }>(function DeltaBadge({ pct }, ref) {
  const abs = Math.abs(pct);
  const neutral = abs < 2;

  if (neutral) {
    return (
      <span ref={ref} className="inline-flex items-center gap-0.5 text-xs text-muted-foreground">
        <Minus className="h-3 w-3" />
        {abs.toFixed(1)}%
      </span>
    );
  }

  const up = pct > 0;
  return (
    <span
      ref={ref}
      className={`inline-flex items-center gap-0.5 text-xs font-medium ${up ? "text-emerald-600" : "text-red-500"}`}
    >
      {up ? <TrendingUp className="h-3 w-3" /> : <TrendingDown className="h-3 w-3" />}
      {abs.toFixed(1)}%
    </span>
  );
});
